
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { CommonService } from '../../Services/common.service';
import { DataTable } from 'angular2-datatable';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators, FormControl, FormGroupDirective, NgForm } from '@angular/forms';
import * as XLSX from 'xlsx';
import { MatPaginator, MatSort, MatTableDataSource, ErrorStateMatcher } from '@angular/material';
import { DatePipe } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { PhoneModelExcelService } from '../../Services/excel.service';
import { WorkBook } from 'xlsx';
import { IMyDpOptions } from 'mydatepicker';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppDataService } from '../../Services/app-data-service';


declare var config: any;
@Component({
  selector: 'app-phone-grade-with-sku',
  templateUrl: './phone-grade-with-sku.component.html',
  styleUrls: ['./phone-grade-with-sku.component.css']
})
export class PhoneGradeWithSkuComponent implements OnInit {
  public dataTableID: any = 0;
  public IsSubmit = false;
  public displayedColumns = ['Category','SKUID', 'Make', 'Model', 'Capacity', 'DeviceFullPrice'];
  //public users : IUsers[]= [];
  public dataSource:any;
  public UserFilterTxt: any = '';
  public AdminID: any;
  public ReportData: any;
  form: FormGroup;
  CurrentRole: any;
  matcher = new MyErrorStateMatcher();
  usermangement: any = false;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('hiddenFormCloseButton') closeAddExpenseModal: ElementRef;
  @ViewChild('hiddenCloseButton') close: ElementRef;
  @ViewChild('fileInput') fileUpload: ElementRef;
  length = 0;
  pageSize = 10;
  pageSizeOptions = [5, 10, 25, 100, 200, 500, 1000, 5000];
  SKUMOdelRecords: any[];
  public DataList = [];
  public ShowUserdrp: any = false;
  public ShowRoledrp: any = true;
  public ShowTeamName: any = false;
  public RoleList: any;
  public TotalUserList: any;
  public UsersList: any;
  public UpdateUser: any = 0;
  public ResetRole: any = 0;
  public IsSupervisor: any = 0;
  public alertBox: any = false;
  public alertMsg: any = '';
  public HasParent: any = 0;
  public SupervisorEnable: any;
  public InspectorEnable: any;
  public confirmBtn: any;
  public okBtn: any = false;
  // public IsActive:boolean
  public EnterpriseList;
  public EnterprisePartenerList;
  public Stores;
  public selectedStore;
  public selectedStoreId;
  public selectedEnterprisePartner;
  public Userlist;
  public selectedEnterprise;
  public UserInfo
  enterpriseClientData: any;
  UserData: any;
  EnterprisePartenerModalList: any;
  StoreDetails: any;
  AllStoreDetails: any;
  data: any[];
  ShowModle: boolean = false;
  GradeTable: any;
  arrayBuffer: any;
  ExcelSheet: any;
  excelSheetData: any[];
  modalData: any[] = [];
  excelDataFlag: boolean = true;

  DeviceCategoryList : any;
  DeviceCategoryID : any= config.DeviceCategoryID;
  DeviceCategory: any= 'Phones and iPads';
  SelectedFileDeviceCategory : any;
  selectedDateMessage :any;
  public Datemodel: any;
  public myDatePickerOptions: IMyDpOptions = {
    // other options...
    dateFormat: 'mm/dd/yyyy',
    showClearDateBtn: false,
    editableDateField: false,
    disableUntil: { year: (new Date()).getFullYear(), month: (new Date()).getMonth() + 1, day: (new Date()).getDate() - 1 },
  };
  fileName: any;
  ChoosefileName: string;
  filteredErrorDetails: any;
  filteredSuccessDetails:any[];
  matdatasource: MatTableDataSource<any>;
  public ErrorResponse: boolean= false;
  public SuccessResponse: boolean= false;
  SuccesShow: boolean = false;
  errorShow: boolean = false;
  btndisable: boolean = true;

  constructor(private excelService: PhoneModelExcelService,
    private appData: AppDataService,
    private fb: FormBuilder, private datePipe: DatePipe,
    private spinner: NgxSpinnerService, private _service: CommonService, private router: Router, private toasterservice: ToastrService) {



  }
  ngOnInit() {
    this.selectedEnterprise = '0';
    this.selectedEnterprisePartner = '0';
    this.selectedStoreId = '0';
    this.ChoosefileName="Choose File";
    this.UserInfo = JSON.parse(sessionStorage.getItem('user'));
    if (this.UserInfo == null) {
      this.router.navigate(['/login']);
    }
    // this.spinner.show();

    sessionStorage.removeItem('Records');
    this.CurrentRole = sessionStorage.getItem('role');
    this.Datemodel = { date: { year: (new Date()).getFullYear(), month: (new Date()).getMonth() + 1, day: (new Date()).getDate() } };
   // this.getDeviceCategoryList();
    this.GetPhoneSKUIDList(config.DeviceCategoryID);
  }

  onDateChanged(event) {
    debugger
    this.selectedDateMessage = '';
    const formattedDate = new Date(event.formatted);
    const today = this.isToday(formattedDate);
    if (today) {
      this.selectedDateMessage = 'The new prices will be applicable immediately after a successful upload';
    } else {
      this.selectedDateMessage = 'The new prices will be applicable from ' + event.formatted + ' 00.00.00 HRS after the successful upload';
    }
  }

  isToday(someDate) {
    const today = new Date();
    return someDate.getDate() === today.getDate() &&
      someDate.getMonth() === today.getMonth() &&
      someDate.getFullYear() === today.getFullYear();
  }

  getDeviceCategoryList() {
    debugger
    this.spinner.show();
    debugger
    this._service.Get('api/GetDeviceCategoryList/' + config.EnterprisePartnerID).then(result => {
      debugger;
      this.spinner.hide();
      if (result && result != null) {
        debugger;
        this.DeviceCategoryList = result;
        this.DeviceCategoryID = 0;
      }
    },
      error => {
        console.log(error);
      }
    );
  }

  OnChangeDeviceCategory(DeviceCategoryID) {
    if (DeviceCategoryID > 0) {

      this.DeviceCategory = this.DeviceCategoryList.find(x => x.DeviceCategoryID === Number(DeviceCategoryID)).DeviceCategory;
      this.GetPhoneSKUIDList(DeviceCategoryID);
    }
  }


  PhoneGradePriceSave() {
    const parm = {
      data: this.excelSheetData
    }
    this.spinner.show();
    this._service.getPhoneData(parm, 'Api/PhoneGrade/PhoneSKUPriceBulkSave').then((result: any) => {
      debugger
      this.spinner.hide();
      if (result) {
        sessionStorage.setItem('Records', JSON.stringify(this.GradeTable));
        this.GradeTable = [];
        this.modalData = [];
        this.ShowModle = false;
        this.fileUpload.nativeElement.value = ''
        this.toasterservice.success(this.excelSheetData.length + ' records successfully uploaded ');
        this.router.navigate(['/grade-based-prices']);

      }
    });

  }




  ReviewPhoneGradePrice() {
    debugger
    this.appData.PhoneModelsData = this.GradeTable;
    //this.SKUMOdelRecords=this.GradeTable.SkuModelData;
    sessionStorage.removeItem('translationdata');

    const formatteddate = this.Datemodel.date.month + '/' + this.Datemodel.date.day + '/' + this.Datemodel.date.year;
    sessionStorage.setItem('PriceSelectedDate', formatteddate);
    sessionStorage.setItem('Records', JSON.stringify(this.GradeTable));
    this.router.navigate(['/grade-based-prices']);
  }


  CalculatePriceDeduction(DeviceCategoryID, CategoryData) {
    debugger;
    const formatteddate = this.Datemodel.date.month + '/' + this.Datemodel.date.day + '/' + this.Datemodel.date.year;

    const GradeList = JSON.parse(sessionStorage.getItem('array'));
    const deduction_a = GradeList.find(x => x.GradeID === 1).Deduction;
    const deduction_b = GradeList.find(x => x.GradeID === 2).Deduction;
    const deduction_c = GradeList.find(x => x.GradeID === 3).Deduction;
    const deduction_d = GradeList.find(x => x.GradeID === 4).Deduction;
    const deduction_e = GradeList.find(x => x.GradeID === 5).Deduction;
    const deduction_n = GradeList.find(x => x.GradeID === 6).Deduction;
    const DeviceCategoryItem = this.DeviceCategoryList.find(x => x.DeviceCategoryID === Number(DeviceCategoryID));

    if (CategoryData && CategoryData.SkuModelData && CategoryData.SkuModelData.length > 0) {
      CategoryData.PriceEdit = "price-warning";
      CategoryData.SkuModelData.forEach(element => {
        element.MaxPrice = element.DeviceFullPrice;
        element.DeviceCategoryID = DeviceCategoryID,
          element.DeviceCategory = CategoryData.DeviceCategory,
          element.StartDate = formatteddate;
        element.EndDate = null;
        element.Grade_A = Math.round(element.MaxPrice - ((element.MaxPrice * deduction_a) / 100)).toFixed(2);
        element.Grade_B = Math.round(element.MaxPrice - ((element.MaxPrice * deduction_b) / 100)).toFixed(2);
        element.Grade_C = Math.round(element.MaxPrice - ((element.MaxPrice * deduction_c) / 100)).toFixed(2);
        element.Grade_D = Math.round(element.MaxPrice - ((element.MaxPrice * deduction_d) / 100)).toFixed(2);
        element.Grade_E = Math.round(element.MaxPrice - ((element.MaxPrice * deduction_e) / 100)).toFixed(2);
        element.Grade_N = Math.round(element.MaxPrice - ((element.MaxPrice * deduction_n) / 100)).toFixed(2);
      });

      DeviceCategoryItem.SkuModelData = CategoryData.SkuModelData;
      DeviceCategoryItem.PriceEdit = "price-warning";
    } else {
      DeviceCategoryItem.SkuModelData = [];
      DeviceCategoryItem.PriceEdit = "";
    }


    this.spinner.hide();

  }

  UploadClick(): void {
    debugger
    this.GradeTable = [];
    if (this.excelSheetData !== undefined && this.excelSheetData.length !== 0  ) {
      this.ShowModle = true;
      // this.GradeTable = this.excelRawData;
      this.SelectedFileDeviceCategory = this.excelSheetData[0].Category;
      const DeviceCategoryID = this.DeviceCategoryID;

      const data = sessionStorage.getItem('Records');
      if (data && data !== null && data !== '') {
        this.GradeTable = JSON.parse(data);
        this.GradeTable = this.GradeTable.filter(x => x.DeviceCategory !== this.SelectedFileDeviceCategory);
      }

    const formatteddate = this.Datemodel.date.month + '/' + this.Datemodel.date.day + '/' + this.Datemodel.date.year;
    const GradeListarray = JSON.parse(sessionStorage.getItem('array'));
    // const deduction_a = GradeListarray.find(x => x.GradeID === 1).Deduction;
    // const deduction_b = GradeListarray.find(x => x.GradeID === 2).Deduction;
    const deduction_c = GradeListarray.find(x => x.GradeID === 1).Deduction;
    const deduction_d = GradeListarray.find(x => x.GradeID === 2).Deduction;
    const deduction_e = GradeListarray.find(x => x.GradeID === 3).Deduction;
    const deduction_f = GradeListarray.find(x => x.GradeID === 4).Deduction;
      this.excelSheetData.forEach(element => {
        element.MaxPrice = element.DeviceFullPrice;
        element.DeviceCategoryID = DeviceCategoryID,
        element.DeviceCategory = this.SelectedFileDeviceCategory,
        element.StartDate = formatteddate;
        element.EndDate = null;
        // element.Grade_A = Math.round(element.MaxPrice - ((element.MaxPrice * deduction_a) / 100)).toFixed(2);
        // element.Grade_B = Math.round(element.MaxPrice - ((element.MaxPrice * deduction_b) / 100)).toFixed(2);
        element.Grade_C = (element.MaxPrice - ((element.MaxPrice * deduction_c) / 100)).toFixed(2);
        element.Grade_D = (element.MaxPrice - ((element.MaxPrice * deduction_d) / 100)).toFixed(2);
        element.Grade_E = (element.MaxPrice - ((element.MaxPrice * deduction_e) / 100)).toFixed(2);
        element.Grade_F = (element.MaxPrice - ((element.MaxPrice * deduction_f) / 100)).toFixed(2);
      });


      this.GradeTable.push(
        {
          DeviceCategory: this.SelectedFileDeviceCategory,
          DeviceCategoryID: DeviceCategoryID,
          SkuModelData: this.excelSheetData,
        });
      sessionStorage.setItem('Records', JSON.stringify(this.GradeTable));
    }

    else if (this.excelSheetData.length == 0) {
      this.fileUpload.nativeElement.value = '';
      this.toasterservice.error("Invalid Price File");
      this.excelSheetData = [];
    }
    else {
      this.toasterservice.error("Please Select File")
    }
  }
  GetPhoneSKUIDList(DeviceCategoryID): void {
    debugger
    this.spinner.show();
    const param = {
      EnterprisePartnerID: 0,
      IsModelOverride: true,
      DeviceCategoryID: config.DeviceCategoryID,
    };
    this._service.getData(param, 'api/v2/Pricing/getmodeldetailsforprice').then(res => {
      debugger
      this.SKUMOdelRecords = res;
      //sessionStorage.setItem('skumodellist', JSON.stringify(this.SKUMOdelRecords));
      this.spinner.hide();
      console.log('SKU List from DB');
    });

  }

  exportAsXLSX(): void {
    debugger
    var data = []
    // var startdate= this.datePipe.transform(new Date(),'dd-MM-yyyy');
    // let date:Date = new Date();
    //  var endDate= this.datePipe.transform(date.setDate(date.getDate()+14),'dd-MM-yyyy');
    this.SKUMOdelRecords.forEach(element => {

      let StorageCapacity = 'N/A';
      if (element.StorageCapacity > 0) {
        StorageCapacity = element.StorageCapacity + ' ' + element.MeasurementUnitType;
      }
      const res = {
        Category: this.DeviceCategory,
        SKUID: element.SKUID,
        Make: element.DeviceVendor,
        Model: element.DeviceModel,
        Capacity: StorageCapacity,
        MaximumPrice: element.Price,
        // StartDate:startdate,
        // EndDate:endDate
      };
      data.push(res);
    });
    this.data = this.SKUMOdelRecords;
    debugger;
    var categoryName = this.DeviceCategory;
    categoryName = categoryName.replaceAll(' ', '').replaceAll('&', '_');

    const strtext = JSON.parse(JSON.stringify(data).split('StartDate').join('StartDate(dd-mm-yyyy)')
      .split('EndDate').join('EndDate(dd-mm-yyyy)'));
    this.excelService.exportAsExcelFile(strtext, categoryName);
    this.toasterservice.success('Sample Price file downloaded successfully');
  }

  ReadFile(event: any) {
debugger
    if (event.target.files[0].name.split('.').pop() === 'xlsx') {
      this.ExcelSheet = [];
      this.modalData = [];
      this.excelSheetData = [];
      this.ExcelSheet = event.target.files[0];
      // var newFileName = 'aa'
      //           var formData = new FormData();
      //           formData.append('file', event.target.files[0].name, newFileName);
     // event.target.files[0].name = 'modified-'+event.target.files[0].name;
      this.ChoosefileName=event.target.files[0].name;
      this.fileUpload.nativeElement.value = ''
      this.btndisable= false;
     // event.target.files[0].name ='Demo'
      this.getExcelFile();
      //event.srcElement.value='';
    }
    else {
      this.fileUpload.nativeElement.value = ''
      this.toasterservice.error('Please Select excel file')
    }
  }
  getExcelFile() {
    debugger

    this.spinner.show();
    let fileReader = new FileReader();
    fileReader.onload = (e) => {
      //debugger
      this.arrayBuffer = fileReader.result;
      var data = new Uint8Array(this.arrayBuffer);
      //
      var arr = new Array();
      for (var i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
      //
      var bstr = arr.join('');
      let workbook: WorkBook = XLSX.read(bstr, { type: 'binary' });
      var first_sheet_name = workbook.SheetNames[0];
      var worksheet = workbook.Sheets[first_sheet_name];

      var excel_data = XLSX.utils.sheet_to_json(worksheet, { raw: true });
      // this.excelRawData = excel_data;
      this.excelSheetData = [];
      //
      excel_data.forEach(current_value => {
      //  debugger
        let datetext = this.Datemodel.date.month + '-' + this.Datemodel.date.day + '-' + this.Datemodel.date.year;
        let startdate = this.datePipe.transform(new Date(datetext), 'dd-MM-yyyy');
        let endDate = this.datePipe.transform(new Date(datetext), 'dd-MM-yyyy');

      //  if (current_value['MaximumPrice'] !== undefined  && current_value['MaximumPrice'] !== "") {
          const exceldata = {
            CatalogPartnerId: 0,
            Category: current_value['Category'],
            SKUID: current_value['SKUID'],
            DeviceFullPrice: current_value['MaximumPrice'],
            DeviceModel: current_value['Model'],
            DeviceVendor: current_value['Make'],
            StorageCapacity: current_value['Capacity'],
            StartDate: '',
            EndDate: '',

            //  IsActive:1
          };
          this.excelSheetData.push(exceldata);
      
        this.spinner.hide();
      });
     // this.excelSheetData = this.excelSheetData.filter(x => x.DeviceFullPrice !== undefined);
     this.errorShow = false; 
     this.SuccesShow = false; 
      var PATTERN =/^\d{0,8}(\.\d{1,4})?$/
      // /[a-zA-Z&_\-]/;
     this.filteredErrorDetails =  this.excelSheetData.filter(function (str) { return !PATTERN.test(str.DeviceFullPrice); });
     if(this.filteredErrorDetails.length >= 1 )
     {
      this.errorShow = true; 
     }
     this.filteredSuccessDetails =  this.excelSheetData.filter(function (str) { return PATTERN.test(str.DeviceFullPrice); });
    if(this.filteredSuccessDetails.length >= 1 )
    {
      this.SuccesShow  = true;
      this.excelSheetData = this.filteredSuccessDetails ;
    }
    else{
      this.excelSheetData =  this.excelSheetData;
      
     // this.errorShow = true;
    }
    // else{
    //   this.excelSheetData 
    // }
     
     //  if(this.filteredErrorDetails != undefined && this.filteredErrorDetails != null   )
    //  {
    //   this.excelSheetData = [];
    //   this.excelSheetData = this.filteredSuccessDetails ;

    //  }
    //  else{
    //   this.excelSheetData = this.excelSheetData.filter(x => x.DeviceFullPrice !== undefined);
    //  }
  
     
      this.spinner.hide();

    };
    fileReader.readAsArrayBuffer(this.ExcelSheet);

  }
  getEnterprisePartnerModal() {
    const parameters = {
      EnterPriseID: this.selectedEnterprise
    }
    this._service.getData(JSON.stringify(parameters), 'api/getEnterprisePartner').then(
      result => {
        this.EnterprisePartenerModalList = result;
      })
  }
  getEnterprisePartnerList() {
    const parameters = {
      EnterPriseID: this.selectedEnterprise
    }
    this._service.getData(JSON.stringify(parameters), 'api/getEnterprisePartner').then(
      result => {
        this.EnterprisePartenerList = result;
      })
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  _AllowCharacterOnly(event: any) {
    const pattern = /[a-zA-Z\b\0 ]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
  Cancel()
{
  debugger
  //sessionStorage.removeItem('Records');
   this.ShowModle=false;
}
exportAsXLSXSuccesssLogs(): void {
  debugger
  var data = []
  // var startdate= this.datePipe.transform(new Date(),'dd-MM-yyyy');
  // let date:Date = new Date();
  //  var endDate= this.datePipe.transform(date.setDate(date.getDate()+14),'dd-MM-yyyy');
  this.filteredSuccessDetails.forEach(element => {

    // let StorageCapacity = 'N/A';
    // if (element.StorageCapacity > 0) {
    //   StorageCapacity = element.StorageCapacity + ' ' + element.MeasurementUnitType;
    // }
    const res = {
      Category: this.DeviceCategory,
      SKUID: element.SKUID,
      Make: element.DeviceVendor,
      Model: element.DeviceModel,
      Capacity: element.StorageCapacity,
      MaximumPrice: element.DeviceFullPrice,
      // StartDate:startdate,
      // EndDate:endDate
    };
    data.push(res);
  });
  this.data = this.SKUMOdelRecords;
  debugger;
  var categoryName = this.DeviceCategory;
  categoryName = categoryName.replaceAll(' ', '').replaceAll('&', '_');

  const strtext = JSON.parse(JSON.stringify(data).split('StartDate').join('StartDate(dd-mm-yyyy)')
    .split('EndDate').join('EndDate(dd-mm-yyyy)'));
  this.excelService.exportAsExcelFile(strtext, "SuccessLogs");
  this.toasterservice.success('Success logs price file downloaded successfully');
}
exportAsXLSXErrorLogs(): void {
  debugger
  var data = []
  // var startdate= this.datePipe.transform(new Date(),'dd-MM-yyyy');
  // let date:Date = new Date();
  //  var endDate= this.datePipe.transform(date.setDate(date.getDate()+14),'dd-MM-yyyy');
  this.filteredErrorDetails.forEach(element => {

    // let StorageCapacity = 'N/A';
    // if (element.StorageCapacity > 0) {
    //   StorageCapacity = element.StorageCapacity + ' ' + element.MeasurementUnitType;
    // }
    const res = {
      Category: this.DeviceCategory,
      SKUID: element.SKUID,
      Make: element.DeviceVendor,
      Model: element.DeviceModel,
      Capacity: element.StorageCapacity,
      MaximumPrice: element.DeviceFullPrice != undefined ? element.DeviceFullPrice: '',
      ErrorMessage: 'Device Price is not valid'
     
    };
    data.push(res);
  });
  //this.data = this.SKUMOdelRecords;
  debugger;
  var categoryName = this.DeviceCategory;
  categoryName = categoryName.replaceAll(' ', '').replaceAll('&', '_');

  const strtext = JSON.parse(JSON.stringify(data).split('StartDate').join('StartDate(dd-mm-yyyy)')
    .split('EndDate').join('EndDate(dd-mm-yyyy)'));
  this.excelService.exportAsExcelFile(strtext, "ErrorLogs");
//this.toasterservice.success('Sample Price file downloaded successfully');
  this.toasterservice.success('Fail logs price file downloaded successfully');
}
GetErrorResponse()
{
 
  debugger
  this.ErrorResponse = true;
  this.matdatasource = new MatTableDataSource([]);
  this.matdatasource.data = this.filteredErrorDetails;

  this.dataSource = new MatTableDataSource(this.filteredErrorDetails);
  this.dataSource.paginator = this.paginator;
  this.dataSource.sort = this.sort;

}
GetSuccessResponse()
{
 
  debugger
  this.SuccessResponse = true;
  this.matdatasource = new MatTableDataSource([]);
  this.matdatasource.data = this.filteredSuccessDetails;

  this.dataSource = new MatTableDataSource(this.filteredSuccessDetails);

  this.dataSource.paginator = this.paginator;
  this.dataSource.sort = this.sort;
}
}






export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const invalidCtrl = !!(control && control.invalid && control.parent.dirty);
    const invalidParent = !!(control && control.parent && control.parent.invalid && control.parent.dirty);

    return (invalidCtrl || invalidParent);
  }
}

export interface IUsers {
  UserID: string;
  Name: string;
  UserName: string;
  Email: string;
  Role: string;
  Publish: string;
  Action: string;
}
